module.exports = __webpack_public_path__ + "static/media/Norbord.cb16ace2.svg";